export enum SituationStepInputNames {
  Situations = 'situations',
}
